(function () {
  function initCollapsible(root) {
    if (!root || root.dataset.collapsibleInit === 'true') return;
    root.dataset.collapsibleInit = 'true';

    if (root.dataset.enableReadMore !== 'true') return;

    const textContainer = root.querySelector('[data-collapsible-text]');
    const toggleButton = root.querySelector('[data-collapsible-toggle]');
    const textInner = root.querySelector('[data-collapsible-inner]');
    if (!textContainer || !toggleButton || !textInner) return;

    const collapsedHeight = parseInt(root.dataset.collapsedHeight, 10) || 200;
    const readMoreLabel = toggleButton.dataset.readMoreLabel || 'Read more';
    const readLessLabel = toggleButton.dataset.readLessLabel || 'Read less';

    if (textInner.scrollHeight <= collapsedHeight) {
      root.classList.add('is-ready');
      return;
    }

    const fade = root.querySelector('[data-collapsible-fade]');
    const reducedMotionQuery = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : { matches: false };

    textContainer.classList.add('is-collapsible');
    if (fade) fade.hidden = false;
    toggleButton.hidden = false;
    root.classList.add('is-ready');

    textContainer.addEventListener('transitionend', function (event) {
      if (event.target !== textContainer || event.propertyName !== 'max-height') return;

      if (textContainer.classList.contains('is-expanded')) {
        textContainer.style.maxHeight = 'none';
      } else {
        textContainer.style.removeProperty('max-height');
      }
    });

    toggleButton.addEventListener('click', function () {
      const isExpanded = textContainer.classList.contains('is-expanded');

      if (isExpanded) {
        if (reducedMotionQuery.matches) {
          textContainer.style.removeProperty('max-height');
        } else {
          textContainer.style.maxHeight = textContainer.getBoundingClientRect().height + 'px';
          void textContainer.offsetHeight;
          textContainer.style.maxHeight = collapsedHeight + 'px';
        }

        textContainer.classList.remove('is-expanded');
        toggleButton.textContent = readMoreLabel;
        toggleButton.setAttribute('aria-expanded', 'false');
      } else {
        if (reducedMotionQuery.matches) {
          textContainer.style.maxHeight = 'none';
        } else {
          textContainer.style.maxHeight = textInner.scrollHeight + 'px';
        }

        textContainer.classList.add('is-expanded');
        toggleButton.textContent = readLessLabel;
        toggleButton.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initWithin(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;

    if (scope.matches && scope.matches('[data-collapsible-content]')) {
      initCollapsible(scope);
    }

    const roots = scope.querySelectorAll('[data-collapsible-content]');
    if (!roots.length) return;
    roots.forEach(initCollapsible);
  }

  initWithin(document);

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });
})();
